import { useTranslation } from 'libs/i18n'
import type { BookingStatusType } from '../molecules/BookingStatus/BookingStatus'
import {
	BOOKING_DISPLAY_VARIANTS,
	getBookingDisplayStatus,
	hasBookingStarted,
	type BookingDisplayStatus
} from '../utils/bookingDisplayStatus'

export const useBookingDisplayStatus = () => {
	const { t } = useTranslation()

	const labels: Record<BookingDisplayStatus, string> = {
		scheduled: t('Scheduled'),
		awaitingArrival: t('Awaiting arrival'),
		active: t('Active'),
		expired: t('Expired'),
		overdue: t('Overdue'),
		noShow: t('No show'),
		completed: t('Completed'),
		cancelled: t('Cancelled'),
		abandoned: t('Abandoned')
	}

	return (status: BookingStatusType, startDate: string, endDate: string) => {
		const displayStatus = getBookingDisplayStatus(status, startDate, endDate)

		return {
			label: labels[displayStatus],
			variant: BOOKING_DISPLAY_VARIANTS[displayStatus],
			hasStarted: hasBookingStarted(displayStatus)
		}
	}
}
